import { Spin, Flex } from "antd";

const PageSpinner = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
            }}
        >
            <Flex gap="middle" align="center" vertical>
                <Spin tip="Cargando" size="large" />
            </Flex>
        </div>
    );
};

export default PageSpinner;
